import styled from "styled-components";

export const FooterContainer = styled.div<{ showBackground: boolean }>(({ theme, showBackground }) => ({
    position: "fixed",
    background: showBackground ? theme.colors[theme.colorMode].background_Primary : "none",
    left: 0,
    bottom: 0,
    width: "100%",
    boxShadow: `${theme.spacing.empty} calc(${theme.spacing.xxSmall} * -1) ${theme.spacing.xSmall} ${theme.spacing.empty} rgba(27, 30, 36, 0.04)`,
    borderRadius: `${theme.cornerRadius.medium} ${theme.cornerRadius.medium} ${theme.cornerRadius.none} ${theme.cornerRadius.none}`,
    transform: "translate3d(0, 0, 0)",
    paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.medium})`,
    zIndex: 2,
    "@supports (-webkit-touch-callout: none)": {
        "@supports (padding-bottom: env(safe-area-inset-bottom))": {
            paddingBottom: `calc(max(env(safe-area-inset-bottom) - ${theme?.spacing?.xSmall}, ${theme?.spacing?.medium}))`,
        },
    },
}));
